import { render, staticRenderFns } from "./gak-chuncheon.en.vue?vue&type=template&id=5f87a568&"
import script from "./gak-chuncheon.en.vue?vue&type=script&lang=js&"
export * from "./gak-chuncheon.en.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports